<template lang="pug">
.video
  .video-nav
    img.close(src='../assets/imgs/close.svg' @click="$router.go(-1)")
  .video-room-wrapper
    #player
</template>

<script>
export default {
  name: 'video',
  mounted () {
    const el = document.getElementById('player');
    let videoScript = document.createElement('script');
    videoScript.src = '//union.bokecc.com/player?vid=200B7C38C8A8324D9C33DC5901307461&siteid=99F117B348066991&autoStart=true&autoplay=true&playerid=0A25BF740EA51439&playertype=1&width=100%&height=100%';
    videoScript.type ='text/javascript';
    el.innerHTML = '';
    el.appendChild(videoScript);

    if (this.$store.state.isMobile) {
      let player = setInterval(() => {
        const video = el.getElementsByTagName('video');
        if (video.length) {
          video[0].play();
          clearInterval(player);
        }
      }, 500)
    }

  }
}
</script>

<style lang="stylus">
.video
  position fixed
  left 0
  right 0
  top 0
  bottom 0
  text-align center
  width 100%
  height 100%
  z-index 99999
  background #000
  transition top 0.5s

  .video-nav
    .close
      width 40px
      position absolute
      left 20px
      top 20px
      cursor pointer
#player
  position absolute
  left 0px
  right 0px
  top 60px
  bottom 60px
  text-align center
  vertical-align middle
  display flex
  justify-content center
  align-items center
.ccH5Poster
  display flex
  align-items center
  img
    height auto !important

</style>


// WEBPACK FOOTER //
// Video.vue?780890d6